<script lang="ts">
  import type { OrgaViewFrameContext } from "../../../../context"
  import type { PageContext } from "../../navigation"
  import CalendarBoardSurface from "./_modules/calendar-board-surface"

  interface Props {
    viewFrameContext: OrgaViewFrameContext
    pageContext: PageContext
  }

  let { viewFrameContext: _viewFrameContext, pageContext }: Props = $props()

  const organization = $derived(pageContext.organization)
  const canManageScheduling = $derived(pageContext.canManageScheduling)
  const allowedIntegrationEmployeeIds = $derived(pageContext.allowedIntegrationEmployeeIds)
  const allowedManageEmployeeIds = $derived(pageContext.allowedManageEmployeeIds)
</script>

{#if organization}
  <CalendarBoardSurface
    {organization}
    {canManageScheduling}
    {allowedIntegrationEmployeeIds}
    {allowedManageEmployeeIds}
  />
{/if}
